import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/client';
import CustomPage from './CustomPage';
import WebIntlProvider from '../../ui/i18n/WebIntlProvider';

const CustomPageLoaderQuery = gql`
    query CustomPageLoaderQuery($companyContractId:String, $pageId:String, $pageDisplayId:String, $companyContractDisplayId:String, $useDraft:Boolean) {
        getCustomPageContents {
            getCustomPageContents(companyContractId: $companyContractId, pageId: $pageId, pageDisplayId: $pageDisplayId, companyContractDisplayId: $companyContractDisplayId, useDraft: $useDraft) {
                customPageCache {
                    pageId
                    companyContractId
                    companyContractDisplayId
                    ...CustomPage_customPageCache
                }
            }
        }
    }
    ${CustomPage.fragments.customPageCache}
`;

const CustomPageLoader = (props) => {

  let {
    companyContractId,
    companyContractDisplayId,
    pageId,
    pageDisplayId,
    useDraft,
  } = props;

  if (!pageId && !companyContractId && (!pageDisplayId && !companyContractDisplayId)) {
    console.log('At least pageId or companyContractId or (pageDisplayId+companyContractDisplayId) must be provided, not processing', this.state);
    return (null);
  }

  let { loading, error, data } = useQuery(CustomPageLoaderQuery, {
    variables: {
      companyContractId,
      companyContractDisplayId,
      pageId,
      pageDisplayId,
      useDraft,
    },
  });

  if (loading) {
    return <div>Loading</div>;
  }

  if (!loading) {
    if (!data || !data.getCustomPageContents || !data.getCustomPageContents.getCustomPageContents || !data.getCustomPageContents.getCustomPageContents.customPageCache) {
      console.log('Data is empty, not returning any data', data);  // TODO return empty blank page?
      return (null);
    }
  }

  return (
    <WebIntlProvider>
      <CustomPage customPageCache={data.getCustomPageContents.getCustomPageContents.customPageCache} />
    </WebIntlProvider>
  );
};


CustomPageLoader.propTypes = {
  companyContractId: PropTypes.string,
  companyContractDisplayId: PropTypes.string,
  pageId: PropTypes.string,
  pageDisplayId: PropTypes.string,
  useDraft: PropTypes.bool,
};

export default CustomPageLoader;
